@if (!!filters && areMobileFiltersOpen) {
  <modal
    (cancel)="cancelMobileFiltersOpen()"
    [condition]="areMobileFiltersOpen"
    [config]="{
      header: { title: filters?.mobileTitle || 'Filter Results' },
      type: 'flyout',
    }"
  >
    <ng-container body>
      <lib-list-view-filters-form
        [filters]="filters"
        [filtersForm]="filtersForm"
        [isMobileView]="true"
        (filtersCleared)="clearFilters()"
        (filtersApplied)="applyFilters()"
        (formCreated)="formCreated.emit()"
        (typeAheadOptionSelected)="typeAheadOptionSelected.emit($event)"
      ></lib-list-view-filters-form>
    </ng-container>
    <ng-container footer>
      <div class="u-flex u-justifyBetween u-maxX">
        <zip-button
          (zipButtonClicked)="clearFilters()"
          [config]="filters.clear"
        >
        </zip-button>
        <zip-button
          (zipButtonClicked)="applyFilters()"
          [config]="filters.submit"
        >
        </zip-button>
      </div>
    </ng-container>
  </modal>
}
